<div class="d-inline-block mr-4">
  <nz-input-group class="extInput" [nzPrefix]="prefixIconSearch">
    <input nz-input (focus)="setVisible()" placeholder="{{ 'topBar.typeToSearch' | translate }}" style="width: 200px" />
  </nz-input-group>
  <ng-template #prefixIconSearch>
    <i nz-icon nzType="search" class="extInputIcon" style="color: rgba(0,0,0,.25)"></i>
  </ng-template>
  <div class="livesearch" [ngClass]="{'livesearchVisible': showSearch}">
    <button class="close" type="button" (click)="setHidden()">
      <i class="icmn-cross"></i>
    </button>
    <div class="container-fluid">
      <div class="wrapper">
        <input #liveSearchInput [(ngModel)]="searchText" class="searchInput"
          placeholder="{{ 'topBar.typeToSearch' | translate }}" />

        <div *ngIf="!searchText" class="results">
          <div class="resultsTitle">
            <span>No Results Found</span>
          </div>
        </div>
        <div *ngIf="searchText" class="results">
          <div class="resultsTitle">
            <span>Pages Search Results</span>
          </div>
          <div class="row">
            <div class="col-lg-6" *ngFor="let service of displayedServices">
              <div class="resultContent">
                <div class="resultThumb" style="background-image: url({{service.image}})">
                </div>
                <div class="result">
                  <div class="resultText">
                    <a [routerLink]="['/service/service-details',service.serviceID]" (focus)=setHidden()> {{service.name}} </a>
                  </div> 
                  <div class="resultSource">
                    {{service.platform}}
                  </div>
                </div>
              </div>
              




              
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>